<template>
  <div
    class="flex flex-col items-start justify-between space-y-4 sm:flex-row sm:items-center sm:space-x-4 sm:space-y-0"
  >
    <div class="flex h-10 w-full items-center space-x-4 sm:w-auto">
      <search-input-component
        @input="setSearchFilter"
        :value="getSearchFilter"
        class="w-full"
      />
      <!-- <view-mode-switch-component
        :table="table"
        :showSpinner="showSwitchSpinner"
        @toggle-visualization="toggleVisualization"
      /> -->
    </div>
    <!-- <div
      class="flex h-10 w-full items-center space-x-4 sm:w-auto"
      v-if="getSearchFilter"
    >
      <view-mode-switch-component
        :table="table"
        :showSpinner="showSwitchSpinner"
        @toggle-visualization="toggleVisualization"
        class="flex h-full sm:hidden"
      />
      <ontick-button
        content="Filtros"
        class="text-ontick-steel-300 relative h-full space-x-2 py-2 dark:text-gray-300"
        size="small"
        color="cinza"
        @click.native="setFiltersTabIsActive(true)"
      >
        <i v-html="$icons.filter_sm" />
        <span>Filtrar</span>
      </ontick-button>

      <ontick-button
        class="flex h-full w-full items-center space-x-1 px-2 sm:w-auto"
      >
        <i v-html="$icons.plus"></i>
        <span class="sm:hidden"> Cupom </span>
        <span class="hidden whitespace-nowrap sm:block"> Adicionar cupom </span>
      </ontick-button>
      <add-extension-button-component />
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import searchInputComponent from "../../../shared/components/filters/search-input.component.vue";
import ViewModeSwitchComponent from "../../../shared/components/filters/view-mode-switch.component.vue";
// import AddExtensionButtonComponent from "./add-extension-button.component.vue";
export default {
  components: {
    searchInputComponent,
    ViewModeSwitchComponent,
    // AddExtensionButtonComponent,
  },
  data() {
    return {
      showSwitchSpinner: false,
    };
  },
  computed: {
    ...mapGetters({
      table: "partners/getTableMode",
      getFiltersTabIsActive: "partners/getFiltersTabIsActive",
      getSearchFilter: "partners/getSearchFilter",
    }),
  },
  methods: {
    ...mapActions({
      setTableMode: "partners/setTableMode",
      setSearchFilter: "partners/setSearchFilter",
      setFiltersTabIsActive: "partners/setFiltersTabIsActive",
    }),
    toggleVisualization() {
      this.showSwitchSpinner = true;
      this.setTableMode();
      this.showSwitchSpinner = false;
    },
  },
  // created() {
  //   const partner_name = this.$route.query.partner_name;
  //   if (partner_name) {
  //     this.setSearchFilter(partner_name);
  //   }
  // },
};
</script>

<style scoped>
.badge {
  @apply bg-ontick-green-500 text-ontick-graphite-500 absolute top-0 right-0 mt-1 ml-1 block h-4 w-4 -translate-y-1/2 translate-x-1/2 transform rounded-full text-xs font-semibold;
}
</style>
